import { render } from "./MethodAdmin.vue?vue&type=template&id=0573cd57&scoped=true"
import script from "./MethodAdmin.vue?vue&type=script&lang=js"
export * from "./MethodAdmin.vue?vue&type=script&lang=js"

import "./MethodAdmin.vue?vue&type=style&index=0&id=0573cd57&scoped=true&lang=css"

import exportComponent from "D:\\Development\\Illyrian\\witsrhi-journeytool-myprep\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0573cd57"]])

export default __exports__